import { render, staticRenderFns } from "./itemsSalesHistory.vue?vue&type=template&id=15ab07ac&scoped=true&"
import script from "./itemsSalesHistory.vue?vue&type=script&lang=js&"
export * from "./itemsSalesHistory.vue?vue&type=script&lang=js&"
import style0 from "./itemsSalesHistory.vue?vue&type=style&index=0&id=15ab07ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ab07ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VEditDialog,VIcon,VSelect,VTextField})
